__turbopack_context__.v({
  "checkbox": "ThemeSelector-module-scss-module__Cl6YRa__checkbox",
  "radioImage": "ThemeSelector-module-scss-module__Cl6YRa__radioImage",
  "radioLabel": "ThemeSelector-module-scss-module__Cl6YRa__radioLabel",
  "selected": "ThemeSelector-module-scss-module__Cl6YRa__selected",
  "themeItem": "ThemeSelector-module-scss-module__Cl6YRa__themeItem",
  "themeSelector": "ThemeSelector-module-scss-module__Cl6YRa__themeSelector",
});
